import { createAction, props } from '@ngrx/store'

import { ELanguage, INotificationMessage } from '~/core/models'

import { uiFeatureKey } from './ui.state'

export const initUi = createAction(`[${uiFeatureKey}] Init UI`)

export const changeThemeMode = createAction(`[${uiFeatureKey}] Change theme mode`, props<{ isDarkTheme: boolean }>())

export const saveThemeMode = createAction(`[${uiFeatureKey}] Save theme mode`, props<{ isDarkTheme: boolean }>())

export const startRequest = createAction(`[${uiFeatureKey}] Start request`)

export const endRequest = createAction(`[${uiFeatureKey}] End request`)

export const changeLanguage = createAction(`[${uiFeatureKey}] Change language`)

export const saveLanguage = createAction(`[${uiFeatureKey}] Save language`, props<{ language: ELanguage }>())

// Notifications

export const addSuccessNotification = createAction(
  `[${uiFeatureKey}] Add Success Notification`,
  props<{ i18nTitle: string; i18nMessage?: string }>()
)

export const addErrorNotification = createAction(
  `[${uiFeatureKey}] Add Error Notification`,
  props<{
    i18nTitle: string
    i18nMessage?: string
    error?: any
  }>()
)

export const addInfoNotification = createAction(
  `[${uiFeatureKey}] Add Info Notification`,
  props<{
    i18nTitle: string
    i18nMessage?: string
  }>()
)

// notifications

export const addNotification = createAction(
  `[${uiFeatureKey}] Add Notification`,
  props<{ notification: INotificationMessage }>()
)

export const removeNotification = createAction(`[${uiFeatureKey}] Remove Notification`, props<{ index: number }>())

export const clearNotifications = createAction(`[${uiFeatureKey}] Clear Notifications`)

export const showNotificationPopup = createAction(`[${uiFeatureKey}] Show Notifications popup`)
